<ion-header>
	<app-account-toolbar (back)="goBack()" src="/assets/icons/barrierefreiheit.svg" title="Barrierefreiheit"></app-account-toolbar>
</ion-header>
